"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ClonerNotification = function (_a) {
    var clonedLink = _a.clonedLink, onClickLink = _a.onClickLink;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        "Page cloned",
        " ",
        react_1.default.createElement(kaleidoscope_1.Button, { href: function () { return clonedLink; }, onClick: onClickLink }, "Go to page")));
};
exports.default = (function (clonedLink, onClickLink) { return (react_1.default.createElement(ClonerNotification, { clonedLink: clonedLink, onClickLink: onClickLink })); });
